// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__327Eb"};